import { humanBeards, humanParts } from './human-parts.js';

export const humanoidBeardDefaults: Record<string, string> = { 'dwarf-male': 'full', 'dwarf-female': 'full' };

/** The same facial-hair restrictions apply to the creator, saved builds and authored figures. */
export function humanoidBeardAllowed(body: string, beard: string): boolean {
  return body.startsWith('goblin-') || body.startsWith('halfling-') || body === 'elf-male' || body === 'elf-female' ? beard === 'none' : body !== 'dwarf-male' || beard !== 'none';
}

/** Celestial wings take the place of a cloak. */
export function humanoidCapeAllowed(body: string, cape: string): boolean {
  return !body.startsWith('celestial-') || cape === 'none';
}

/** Missing or unavailable facial hair resolves to this body's legal default. */
export function humanoidBeard(body: string, beard?: string): string {
  return humanBeards.find(variant => variant.id === beard && humanoidBeardAllowed(body, variant.id))?.id ?? humanoidBeardDefaults[body] ?? 'none';
}

/** An ancestry's choices on the shared head parts and motion rig. */
export function humanoidParts(body: string, motionRig: string, chosen: Record<string, string> = {}): Record<string, string> {
  return humanParts(motionRig, { ...chosen, beard: humanoidBeard(body, chosen.beard), ...humanoidCapeAllowed(body, chosen.cape ?? 'none') ? {} : { cape: 'none' } });
}
